import cross from '@xero/xui-icon/icons/cross';
import XUIActions from '@xero/xui/react/actions';
import XUIButton, { XUIIconButton } from '@xero/xui/react/button';
import XUIIsolationHeader from '@xero/xui/react/components/isolationheader/XUIIsolationHeader';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import WizardPanel from '../../components/WizardPanel';
import { setVisible } from '../../helpers/header';
import { installationSelectors } from '../../redux/slices/InstallationSlice';
import lang from '../../static/lang/en-NZ';
import './Wizard.css';

export interface IWizardProps {
    onWizardComplete: () => void;
    onWizardClose: () => void;
}

const Wizard: FC<IWizardProps> = ({ onWizardComplete, onWizardClose }) => {
    const installation = useSelector(installationSelectors.installation);

    const [step, setStep] = useState(0);

    const integrationLang: any = lang[installation.integrationType];
    const wizardSteps = integrationLang.EDUCATION_FLOW({ hasPaidPlan: installation.billing?.hasPaidPlan });

    useEffect(() => {
        setVisible(false);
    }, []);

    const getTab = () => {
        const nextButtonText = step >= wizardSteps.length - 1 ? lang.BUTTONS.START_SET_UP : lang.BUTTONS.NEXT;
        const actions = (
            <XUIActions isLinear={true}>
                <XUIButton qaHook='wizard-back' onClick={onBackClick} isDisabled={step === 0}>
                    {lang.BUTTONS.BACK}
                </XUIButton>
                <XUIButton qaHook='wizard-next' onClick={onNextClick} variant='main'>
                    {nextButtonText}
                </XUIButton>
            </XUIActions>
        );

        const wizardStep = wizardSteps[step];
        const svg = wizardStep.SVG;

        return <WizardPanel heading={wizardStep.HEADING} content={wizardStep.CONTENT} svg={svg} actions={actions} />;
    };

    const onSkipClick = () => {
        onWizardComplete();
    };

    const onBackClick = () => {
        setStep(step ? step - 1 : step);
    };

    const onNextClick = () => {
        if (step >= wizardSteps.length - 1) {
            onWizardComplete();

            return;
        }

        setStep(step + 1);
    };

    const pageHeader = (
        <XUIIsolationHeader
            isPositionFixed={true}
            navigationButton={
                <XUIIconButton
                    icon={cross}
                    onClick={() => onWizardClose()}
                    ariaLabel='close'
                    data-testid={'wizard-close'}
                />
            }
            title={integrationLang.EDUCATION_FLOW_TITLE}
            actions={
                <a className='xui-text-emphasis' onClick={onSkipClick} data-automationid={'wizard-skip'}>
                    {lang.BUTTONS.SKIP_INTRODUCTION}
                </a>
            }
        />
    );

    return (
        <>
            {pageHeader}
            <div className='xui-u-flex xui-u-flex-justify-center xui-margin-horizontal-auto xui-margin-vertical-5xlarge'>
                {getTab()}
            </div>
        </>
    );
};

export default Wizard;
